<template>
    <div :class="(isSd || isD3) ? 'mgBox sdBox' : 'mgBox'">
        <p class="mgtexp" v-if="isSd||isD3">魔法：</p>
        <el-tooltip class="item" effect="dark" content="独家原创功能：图片一键转视频（永久会员专享）"
            placement="right-start">
            <img src="../views/img/icon_img42.png" class="tips_icon" />
        </el-tooltip>
        <div class="mgDetailBtn" v-if="item.menu_type == 1">
            <!-- <template> -->
                <el-popover class="item" popper-class="mgcTipBox" v-for="val in magList" :key="val.id" trigger="click"> 
                
                    <div class="detBtn" slot="reference" @mouseenter="handleMouseEnter(val.id)"
                        @mouseleave="handleMouseLeave">
                        <!-- <div class="detBtn" @click="magicImg(val, 1)" v-for="val in magList" :key="val.id"> -->

                        {{ val.name }}
                    </div>
                        <div class="mgDetailPopBox">
                            <div class="mgDetailPop">
                                <div class="mgTopBox">
                                
                                    <div class="detailTit detailTittOther">
                                        <!-- <div class="titLogo"> -->
                                        <img src="../views/img/crelogo.svg" alt="">
                                        <!-- </div> -->
                                        <div class="titText">参数设置<div class="vipText"> (终身会员专享功能)</div>
                                        </div>
                                    </div>
                                    <!-- 创意 -->
                                    <div class="detailCreat" @click.stop>
                                        <div class="detailText">创意想象力</div>
                                        <div class="slidBox">
                                            <el-slider v-model="creatNum" :step="0.1" :max="1"></el-slider>
                                        </div>
                                        <div class="detailText">创意相关性</div>
                                    </div>
                                    <!-- 生成模式 -->
                                    <div class="detailModel" @click.stop>
                                        <div class="detailText creatOther">生成模式 : </div>
                                        <!-- <el-tooltip class="item" effect="dark" content="标准:生成快速更快; 高品质:画面质量更佳"
                                            placement="right-start">
                                            <img src="../views/img/mgTip.svg" class="mgTipimg" alt="">
                                        </el-tooltip> -->
                                        <template>
                                            <el-radio v-model="radio" label="1" @input="changeCreate" :key="3">标准</el-radio>
                                            <el-radio v-model="radio" label="2" @input="changeCreate" :key="4">高品质</el-radio>
                                        </template>
                                    </div>

                                    <!-- 生成时长 -->
                                    <div class="detailTime" @click.stop>
                                        <div class="detailText creatOther">生成时长 : </div>
                                        <template>
                                            <div>
                                                <el-radio v-model="vidTim" label="1" @input="changeCreateOther" :key="1">5S</el-radio>
                                                <el-radio v-model="vidTim" class="tenSen" label="2" @input="changeCreateOther" :key="2">10S</el-radio>
                                            </div>
                                        </template>
                                    </div>

                                    <!-- 生成条数 -->
                                    <!-- <div class="detailCnum" @click.stop>
                                        <div class="detailText">生成条数 : <div class="detailn">{{ activenum }} 条</div>
                                        </div>
                                        <div class="numSetBox">
                                            <el-slider v-model="activenum" :min="1" :max="4" :step="1" show-stops
                                                :show-tooltip="false" @change="handleSliderChange">
                                            </el-slider>
                                        </div>
                                    </div> -->
                                </div>

                                <!-- 创意描述 -->
                                <div class="creativeSescription">
                                    <div class="detailTit detailOther detailLinggan">
                                        <img src="./img/yang.svg" class="lingLogo" alt="">
                                    <div class="titText">创意描述<div class="vipText"> (非必填)</div></div>
                                    </div>
                                    <div class="cstText">
                                        <textarea placeholder="例如：让图片中的人物吃汉堡等" v-model="textPrompt" class="cstTextarea"></textarea>
                                    </div>
                                    <div class="detailTit detailLinggan">
                                        <img src="./img/deng.png" class="lingLogo" alt="">
                                        <div class="titText">灵感词库</div>
                                    </div>
                                    <div class="lingganBox">
                                        <div :class="lingAct.includes(lingVid.id) ? 'linItem linItemAct' : 'linItem'"
                                            v-for="lingVid in lingList" :key="lingVid.id" @click="checkLing(lingVid)">
                                            <img :src="lingVid.url" class="lingVideo" alt="">
                                            <!-- <video autoplay muted loop class="lingVideo">
                                                <source :src="lingVid.url" type="video/mp4">
                                            </video> -->
                                            <div class="lingVidName">{{ lingVid.name }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 立即生成 -->
                                <div class="subVideoBtn" @click.stop="magicImg(item, val.id, 'M', 0)">
                                    <div class="svdbTextB">立即生成视频</div>
                                    <div class="svdbTextS">
                                        (消耗{{ mgScore }}积分)
                                    </div>
                                </div>
                                <!-- <div class="triangleLeft"></div> -->
                            </div>
                        </div>
                </el-popover>
            <!-- </template> -->
        </div>
        <el-popover class="item" popper-class="mgcTipBox" trigger="click">        
            <div class="magicBtn" slot="reference" v-if="item.menu_type == 2||item.menu_type == 3"
                @mouseenter="handleOnlyEnter(item.draw_id)" @mouseleave="handleOnlyLeave">
                图片
                <img src="../views/img/rgarro.svg" class="rgarro" alt="">
                视频
            </div>
            <!-- v-if="(onliyID == item.draw_id)" -->
            <div class="mgDetailPopBox">
                <div class="mgDetailPop">
                    <div class="mgTopBox">
                    
                        <div class="detailTit detailTittOther">
                            <img src="../views/img/crelogo.svg" alt="">
                            <div class="titText">参数设置 <div class="vipText"> (终身会员专享功能)</div>
                            </div>
                        </div>
                        <!-- 创意 -->
                        <div class="detailCreat">
                            <div class="detailText">创意想象力</div>
                            <div class="slidBox">
                                <el-slider v-model="creatNum" :step="0.1" :max="1"></el-slider>
                            </div>
                            <div class="detailText">创意相关性</div>
                        </div>
                        <!-- 生成模式 -->
                        <div class="detailModel">
                            <div class="detailText creatOther">生成模式 : </div>
                            <!-- <el-tooltip class="item" effect="dark" content="标准:生成快速更快; 高品质:画面质量更佳" placement="right-start">
                                <img src="../views/img/mgTip.svg" class="mgTipimg" alt="">
                            </el-tooltip> -->
                            <template>
                                <el-radio v-model="radio" label="1" @input="changeCreate" :key="5">标准</el-radio>
                                <el-radio v-model="radio" label="2" @input="changeCreate" :key="6">高品质</el-radio>
                            </template>
                        </div>

                        <!-- 生成时长 -->
                        <div class="detailTime">
                            <div class="detailText creatOther">生成时长 : </div>
                            <template>
                                <div>
                                    <el-radio v-model="vidTim" label="1" @input="changeCreateOther" :key="7">5S</el-radio>
                                    <el-radio v-model="vidTim" class="tenSen" label="2" @input="changeCreateOther" :key="8">10S</el-radio>
                                </div>
                            </template>
                        </div>

                        <!-- 生成条数 -->
                        <!-- <div class="detailCnum">
                            <div class="detailText">生成条数 : <div class="detailn">{{ activenum }} 条</div>
                            </div>
                            <div class="numSetBox">
                                <el-slider v-model="activenum" :min="1" :max="4" :step="1" show-stops :show-tooltip="false"
                                    @change="handleSliderChange">
                                </el-slider>
                            </div>
                        </div> -->
                    </div>

                    <!-- 创意描述 -->
                    <div class="creativeSescription">
                        <div class="detailTit detailOther detailLinggan">
                            <img src="./img/yang.svg" class="lingLogo" alt="">
                            <div class="titText">创意描述 <div class="vipText"> (非必填)</div></div>
                        </div>
                        <div class="cstText">
                            <textarea placeholder="例如：让图片中的人物吃汉堡等" v-model="textPrompt" class="cstTextarea"></textarea>
                        </div>
                        <div class="detailTit detailLinggan">
                            <img src="./img/deng.png" class="lingLogo" alt="">
                            <div class="titText">灵感词库</div>
                        </div>
                        <div class="lingganBox">
                            <div :class="lingAct.includes(lingVid.id) ? 'linItem linItemAct' : 'linItem'"
                                v-for="lingVid in lingList" :key="lingVid.id" @click="checkLing(lingVid)">
                                <img :src="lingVid.url" class="lingVideo" alt="">
                                <!-- <video autoplay muted loop class="lingVideo">
                                    <source :src="lingVid.url" type="video/mp4">
                                </video> -->
                                <div class="lingVidName">{{ lingVid.name }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 立即生成 -->
                    <div class="subVideoBtn" @click="magicImg(item, 0, 'M')">
                        <div class="svdbTextB">立即生成视频111</div>
                        <div class="svdbTextS">
                            (消耗{{ mgScore }}积分)
                        </div>
                    </div>
                    <!-- <div class="triangleLeft"></div> -->
                </div>
            </div>
        </el-popover>
        <canvas ref="localCanvas" style="display: none;" useCORS="true" allowTaint="true"></canvas>
        <mgVipTip :tipshow="isFirst" :changestyle="isD3"></mgVipTip>
    </div>
</template>

<script>
import mgVipTip from './mgVipTip.vue';
import utils from '../utils';

export default {
    components: { mgVipTip },
    props: ['item', 'isSamp', 'isMj', "isSd", "isD3", "isFirst","btn_opt_type"],
    data() {
        return {
            lingAct: [],
            // lingList:[
            //     {
            //         id:0,
            //         name:'固定镜头',
            //         url:require('./videos/固定镜头.mp4')
            //     },
            //     {
            //         id:2,
            //         name:'固定镜头',
            //         url:require('./videos/镜头跟随.mp4')
            //     },
            //     {
            //         id:3,
            //         name:'固定镜头',
            //         url:require('./videos/镜头拉远.mp4')
            //     },
            //     {
            //         id:4,
            //         name:'固定镜头',
            //         url:require('./videos/手持镜头.mp4')
            //     },
            //     {
            //         id:5,
            //         name:'固定镜头',
            //         url:require('./videos/围绕主体运镜.mp4')
            //     }
            // ],
            lingList:
                [
                    // {
                    //     id: 0,
                    //     name: '固定镜头',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/固定镜头.mp4'
                    // },
                    // {
                    //     id: 1,
                    //     name: '围绕主体运镜',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/围绕主体运镜.mp4'
                    // },
                    // {
                    //     id: 2,
                    //     name: '手持镜头',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/手持镜头.mp4'
                    // },
                    // {
                    //     id: 3,
                    //     name: '镜头推进',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/镜头推进.mp4'
                    // },
                    // {
                    //     id: 4,
                    //     name: '镜头拉远',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/镜头拉远.mp4'
                    // },
                    // {
                    //     id: 5,
                    //     name: '镜头跟随',
                    //     url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/mjvideo/镜头跟随.mp4'
                    // }
                ],
            timer: null,
            vipTipCloseTime: 5,
            isVip: true,
            mgScore: 10,
            activenum: 1,
            onliyID: null,//单个tipid
            mgCurrent: null, //局部小id
            allCurr: null,//整体id
            radio: '1',
            vidTim: '1',
            creatNum: 0.5,//创意想象力值
            textPrompt: '',//创意描述
            magList: [
                {
                    id: 0,
                    name: 'M1'
                },
                {
                    id: 1,
                    name: 'M2'
                },
                {
                    id: 2,
                    name: 'M3'
                },
                {
                    id: 3,
                    name: 'M4'
                }
            ],
        }
    },
    computed: {
        user_info() {
            return this.$store.state.userInfo;
        },
        isLogin() {
            return this.$store.state.isLogin;
        },
    },
    // mounted() {
    //     console.log(this.item);

    // },
    methods: {
        changeCreate(data){
            if(data==1){//标准品质
                this.mgScore = this.vidTim=='1'?20*this.activenum:30*this.activenum
            }else{//高品质
                this.mgScore = this.vidTim=='1'?30*this.activenum:50*this.activenum
            }
            this.$forceUpdate()
            
        },
        changeCreateOther(data){
            if(data==1){//5s
                this.mgScore = this.radio=='1'?20*this.activenum:30*this.activenum
            }else{//10s
                this.mgScore = this.radio=='1'?40*this.activenum:50*this.activenum
            }
            this.$forceUpdate()
        },
        checkLing(data) {
            if (!this.lingAct.includes(data.id)) {
                this.lingAct.push(data.id)
                this.textPrompt += data.name
            } else {
                this.lingAct.splice(this.lingAct.indexOf(data.id), 1)
                this.textPrompt = this.textPrompt.replace(new RegExp(`${data.name}`, 'g'), '').trim()
            }
        },
        checkLogin() {
            // 检查登录状态
            if (!this.isLogin) {
                this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
                    confirmButtonText: '立即登录',
                    cancelButtonText: '关闭',
                    type: 'warning'
                }).then(() => {
                    this.$store.commit('setUserInfo', null)
                    this.$store.commit('setIsLogin', false)
                    this.$store.commit('setShowLogin', true)
                }).catch(() => {
                });
                return false;
            } else {
                return true;
            }
        },
        //魔法
        magicImg(item, val, type, loggin) {
            let _this = this
            if (!this.checkLogin()) return
            console.log('魔法opt',this.btn_opt_type);
            
            if(!utils.setOptData(this.user_info,this.btn_opt_type)){
                document.body.click()
                return
            }
            if (this.isSamp) {
                this.$confirm('当前任务为演示数据，暂不支持该操作，请先执行绘画任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '关闭',
                    type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
                return
            }
            if(this.user_info.vip_type != 5){
                this.$confirm("该功能为终身会员专享功能，请升级会员后使用", '提示', {
                    confirmButtonText: '开通会员',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('/member')
                }).catch(() => {

                });
                return
            }
            if(_this.textPrompt.length>200){
                this.$message.error('描述词最大长度不能超过200字符!');
                return
            }
            let img_url = item.raw_img_url
            if (item.pic_num == 1) {//单张生成
                utils.resizeImage(img_url).then(base64Image => {
                    // 可以将base64Image用于显示、上传等操作
                    let parData = {
                        isMagc: true,
                        parent_draw_id: item.draw_id,
                        item_mg: true,
                        mgIndex: val + 1,
                        img_type: "img_video",
                        parameters: {
                            cfg: _this.creatNum,//创意想象
                            img_num: _this.activenum,//图片数量
                            //iw_url:item.raw_img_url,
                            iw_url: base64Image,
                            quality: _this.radio == '1' ? 0 : 1,//模式选择 0非专业 1 专业
                            seconds: _this.vidTim == '1' ? 5 : 10,// 时间 秒
                            text_prompt: _this.textPrompt
                        },
                        prompt_en:item.prompt_en,
                        prompt:item.prompt
                    }
                    _this.$emit('magData', parData)
                    _this.initData()
                }).catch(error => {
                    console.error("Image resizing failed", error);
                });

            } else {
                // console.log(val);
                // this.getMgImg(img_url,val)
                // console.log(val);
                // let img_url = require('../views/img/testa1.png')
                this.split_img_url = img_url
                const canvas = this.$refs.localCanvas;
                let that = this
                var imgRaw = new Image();
                imgRaw.src = img_url
                // imgRaw.src = require('../views/img/testa1.png')
                imgRaw.setAttribute('crossOrigin', 'anonymous');
                imgRaw.onload = function () {
                    var arr = []
                    let canvasWidth = imgRaw.width / 2; // Assuming split in half
                    let canvasHeight = imgRaw.height / 2; // Adjust as needed
                    for (var i = 0; i <= 4; i++) {
                        canvas.width = canvasWidth
                        canvas.height = canvasHeight

                        const ctx = canvas.getContext('2d');
                        const x = i % 2 === 0 ? 0 : canvasWidth;
                        const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

                        ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

                        const base64 = canvas.toDataURL('image/jpeg');
                        arr.push(base64);
                    }
                    // _this.$nextTick(() => {
                    utils.resizeImage(arr[val]).then(base64Image => {
                        let parData = {
                            isMagc: true,
                            parent_draw_id: item.draw_id,
                            item_mg: true,
                            mgIndex: val + 1,
                            img_type: "img_video",
                            parameters: {
                                cfg: _this.creatNum,//创意想象
                                img_num: _this.activenum,//图片数量
                                iw_url: base64Image,
                                quality: _this.radio == '1' ? 0 : 1,//模式选择 0非专业 1 专业
                                seconds: _this.vidTim == '1' ? 5 : 10,// 时间 秒
                                text_prompt: _this.textPrompt
                            }
                        }
                        _this.$emit('magData', parData)
                        _this.initData()
                    })
                    // })
                }

            }
            this.onliyID = null
            this.allCurr = null
            this.mgCurrent = null
        },
        initData() {
            this.textPrompt = ''
            this.radio = '1'
            this.vidTim = '1'
            this.creatNum = 0.5
        },
        handleSliderChange(val) {
            if (this.vidTim == '1') {//标准品质
                // this.mgScore = val * 10
                this.mgScore = this.radio=='1'?10*val:20*val
            } else {//高品质
                // this.mgScore = val * 20
                this.mgScore = this.radio=='1'?20*val:30*val
            }
        },
        handleOnlyEnter(id) {
            this.lingList = [
                    {
                        id: 1,
                        name: '围绕主体运镜',
                        url:require('./img/zhutiweirao.gif')
                    },
                    {
                        id: 2,
                        name: '手持镜头',
                        url:require('./img/shouchi.gif')
                    },
                    {
                        id: 3,
                        name: '镜头推进',
                        url:require('./img/jttuijin.gif')
                    },
                    {
                        id: 5,
                        name: '镜头跟随',
                        url:require('./img/jtgensui.gif')
                    }
            ]
            this.onliyID = id;
        },
        handleOnlyLeave() {
            this.onliyID = null;
        },

        handleMouseEnter(id) {
            this.lingList = [
                    {
                        id: 1,
                        name: '围绕主体运镜',
                        url:require('./img/zhutiweirao.gif')
                    },
                    {
                        id: 2,
                        name: '手持镜头',
                        url:require('./img/shouchi.gif')
                    },
                    {
                        id: 3,
                        name: '镜头推进',
                        url:require('./img/jttuijin.gif')
                    },
                    {
                        id: 5,
                        name: '镜头跟随',
                        url:require('./img/jtgensui.gif')
                    }
            ]
            this.mgCurrent = id;
            if (!this.isVip) {
                this.bgginCountDown()
            }
        },
        handleMouseLeave() {
            this.mgCurrent = null;
            this.vipTipCloseTime = 5
            // this.textPrompt = ''
            clearInterval(this.timer)
            // this.initData()
        },
    }
}
</script>

<style lang="scss" scoped>
.lingLogo {
    width: 18px;
    height: 18px;
}
.creativeSescription{
    // margin-left: 20px;
    margin-top: 8px;
}

.lingganBox {
    width: 400px;
    height: 100px;
    overflow-y: auto;
    // overflow-x: auto;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 5px;
   

    .linItem {
        position: relative;
        width: 88px;
        height: 88px;
        margin-bottom: 10px;
        margin-right: 8px;
        cursor: pointer;

        .lingVideo {
            width: 100%;
            height: 100%;
        }
    }

    .lingVidName {
        position: absolute;
        width: 88px;
        height: 20px;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0, 0, 0, .5);
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 12px;
    }

    .linItemAct {
        border: 1px solid #5865f2;
    }
}

.sdBox {
    margin-top: 10px;
}

.mgBox {
    display: flex;
    align-items: center;
    position: relative;
  margin-top: 10px;
    .mgtexp {
        font-size: 14px;
        color: #fff;
    }
}

.magicBtn {
    width: 210px;
    height: 30px;
    border-radius: 4px;
    font-size: 14px;
    color: #000;
    background: linear-gradient(to right, rgb(99, 231, 82), rgb(167, 255, 27));
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 8px;
    position: relative;

    .rgarro {
        width: 18px;
        height: 14px;
        margin: 0 35px;
    }

    .options_list {
        margin-top: 10px;


    }


    p {
        font-size: 14px;
        color: #fff;
    }

    .tips_icon {
        width: 14px;
        height: 14px;
        opacity: 0.5;
    }

    span {
        font-size: 13px;
        width: 58px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #4e5058;
        margin-left: 8px;
        border-radius: 3px;
        cursor: pointer;

        img {
            width: 18px;
            height: 18px;
        }

        &:hover {
            background: #6e717c;
        }

        &.span {
            width: 100px;

            img {
                margin-right: 5px;
            }
        }

        &.span2 {
            width: 40px;
        }
    }

    .redraw {
        img {
            height: 20px;
        }

        line-height: 32px;
    }

    .btn {

        &:not(:last-child) {
            margin-right: 0px;
        }

        &.loading {
            opacity: 0.6;

            svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
            }
        }

        &.redraw2 {
            background-color: #f5f6fb;

            img {
                height: 30px;
            }
        }

        &.disabled {
            cursor: not-allowed;
            background-color: #ddd;
            color: #666;
        }
    }

    //
}

.mgDetailBtn {
    // margin-top: 10px;
    margin-left: 8px;
    display: flex;



    .detBtn {
        width: 58px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-size: 14px;
        background: rgb(103, 232, 79);
        margin-right: 8px;
        cursor: pointer;
        position: relative;
    }
}

.mgDetailBtn .detBtn:nth-child(1) {
    background: linear-gradient(to right, rgb(103, 232, 79), rgb(103, 232, 79));
    /* 渐变色1 */
}

.mgDetailBtn .detBtn:nth-child(2) {
    background: linear-gradient(to right, rgb(123, 239, 63), rgb(123, 239, 63));
    /* 渐变色1 */
}

.mgDetailBtn .detBtn:nth-child(3) {
    background: linear-gradient(to right, rgb(145, 247, 45), rgb(145, 247, 45));
    /* 渐变色1 */
}

.mgDetailBtn .detBtn:nth-child(4) {
    background: linear-gradient(to right, rgb(167, 255, 27), rgb(167, 255, 27));
    /* 渐变色1 */
}

// .VipPopBox {
//     position: absolute;
//     width: 400px;
//     z-index: 10;
//     right: -400px;
//     bottom: 0;

// }
.mgDetailPopBox {
    width: 100vw;
    height: 570px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    .detailLinggan{
        display: flex;
        align-items: center;
        margin-top: 0 !important;
        margin: 15px 0 !important;
        .titText{
            font-size: 14px !important;
        }
    }
    .mgTopBox{
        width: 100%;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
        // padding-left: 20px;
    }

    .mgDetailPop {
        .creatOther{
            margin-right: 20px;
        }
        .tenSen{
            margin-left: 12px;
        }
        width: 100vw;
        height: 100%;
        // height: 485px;
        // padding-left: 20px;
        // margin-left: 10px;
        position: relative;
        // background: linear-gradient(to bottom,
        //         rgba(24, 33, 41, 0.7) 0%,
        //         rgba(24, 33, 41, 0.75) 5%,
        //         rgba(24, 33, 41, 0.8) 10%,
        //         rgba(24, 33, 41, 0.85) 15%,
        //         rgba(24, 33, 41, 0.9) 20%,
        //         rgba(24, 33, 41, 0.95) 25%,
        //         rgba(24, 33, 41, 0.96) 35%,
        //         rgba(24, 33, 41, 0.96) 55%,
        //         rgb(24, 33, 41) 40px);
        background: rgb(24, 33, 41);
        border-radius: 8px;
        display: flex;
        flex-direction: column;

        .detailText {
            font-size: 14px;
            color: rgb(117, 119, 133);
            font-weight: 600;
            display: flex;
            align-items: center;
        }

        .detailTit {
            display: flex;
            align-items: center;
            margin-top: 24px;

            .lingganBox {
                display: flex;
                margin-left: 180px;

                .deng {
                    color: rgb(130, 250, 194);
                }

                .titText {
                    color: #82fac2;
                    font-size: 14px;
                }
            }

            .titLogo {
                width: 24px;
                height: 24px;
            }

            .titText {
                font-size: 18px;
                color: #fff;
                font-weight: 500;
                margin-left: 10px;
                display: flex;

                // align-items: center;
                .vipText {
                    color: rgb(117, 119, 133);
                    margin-left: 10px;
                    font-size: 14px;
                    align-self: self-end;
                }
            }
        }
        .detailOther{
            margin-top: 10px;
            margin-left: 2px;
        }
        .detailTittOther{
            margin-bottom: 10px;
        }
        .detailCreat,
        .detailModel,
        .detailTime,
        .detailCnum {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 20px 0;
        }
        .detailCreat{
            display: flex;
            flex-wrap: nowrap;
            margin-top: 20px;
        }

        .detailModel {
            .mgTipimg {
                width: 15px;
                height: 15px;
                margin-left: 8px;
                margin-right: 15px;
                
            }
        }

        .detailTime {

            // .vidTimerbox {
            //     margin-left: 31px;
            // }
        }
        .detailCnum {
            .detailn {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                margin-left: 10px;
            }

            .numSetBox {
                width: 290px;
                height: 5px;
                border-radius: 5px;
                // background:rgb(51, 58, 69);
                position: relative;
                margin-left: 85px;

                .setNmubtn {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: rgb(51, 58, 69);
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .cstText {
            width: 100%;
            height: 90px;
            margin-top: 10px;
            border-radius: 4px;

            .cstTextarea {
                width: calc(100% - 20px);
                height: 100%;
                border: none;
                background-color: black;
                color: white;
                line-height: 30px;
                padding: 10px;
                font-size: 14px;
                word-spacing: 5px;
                border-radius: 6px;
            }
        }

        .subVideoBtn {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 16px;
            color: #000;
            background: linear-gradient(to right, rgb(167, 255, 27), rgb(98, 238, 247));
            border-radius: 4px;
            // margin-bottom: 15px;
            position: relative;
            // margin-top: 13px;
            // margin-left: 20px;
            // margin: 0 auto;
            

            .svdbTextB {
                position: absolute;
                top: 50%;
                left: 107px;
                transform: translateY(-50%);
            }

            .svdbTextS {
                position: absolute;
                bottom: 20px;
                left: 214px;
                font-size: 12px;
            }
        }

        .triangleLeft {
            width: 0;
            height: 0;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-right: 6px solid #182129;
            position: absolute;
            bottom: 15px;
            left: -6px;
        }

        // background: linear-gradient(to bottom, rgba(29, 43, 49,.8), rgb(24, 33, 41))
    }
}
</style>

<style lang="scss">
    .mgcTipBox{

        .el-radio input[aria-hidden="true"] {
        display: none !important;
        }

        .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
        }

        background: none !important;
        color: none !important;
        padding: 0 !important;
        .el-tooltip__popper.is-dark{
            background: none !important;
            color: none !important;
        }
        .el-tooltip__popper{
            padding: none !important;
        }
    
        .slidBox {
            width: 210px;
            height: 5px;
            margin: 0 15px;
    
            .el-slider__bar {
                background: transparent;
            }
    
            .el-slider__runway {
                height: 5px;
                margin: 0 !important;
                background: linear-gradient(to right, rgb(168, 255, 26), rgb(96, 237, 255)) !important;
                // margin-left: 5px;
            }
    
            .el-slider__button {
                background: linear-gradient(to right, rgb(168, 255, 26), rgb(96, 237, 255));
                border: 1px solid #fff;
            }
        }
    
        .detailModel,
        .detailTime {
            .el-radio__input.is-checked .el-radio__inner {
                background: rgb(27, 229, 236);
                background-color: rgb(27, 229, 236);
            }
    
            .el-radio__input.is-checked+.el-radio__label {
                color: #fff;
            }
    
            .el-radio__inner {
                width: 15px;
                height: 15px;
                background: transparent;
                // background: rgb(27, 229, 236);
            }
    
            .el-radio__label {
                font-size: 14px;
                font-weight: 600;
                color: #fff;
            }
        }
    
        .detailCnum {
            .el-slider__stop {
                width: 12px;
                height: 12px;
                top: -2px;
                background: rgb(51, 58, 69);
            }
    
            .el-slider__button {
                border: none;
                background: rgb(78, 80, 98);
            }
    
            .el-slider__runway {
                background: rgb(51, 58, 69);
            }
    
            .el-slider__bar {
                background: rgb(78, 80, 98);
            }
        }
    }
    .mgBox{
        .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
        }
    }
</style>